'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORMAT_SMS = exports.FORMAT_ONETOUCH = exports.FORMAT_CALL = exports.schema = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _config = require('../utils/config');

var _http = require('../utils/http');

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AUTHY_API_KEY = 'authyAPIKey';
var MESSAGE = 'message';
var REGISTER_ENDPOINT = 'registerEndpoint';
var REQUIRE_TWO_FACTOR = 'requireTwoFactor';
var SEND_ENDPOINT = 'sendEndpoint';
var TWO_FACTOR_SUCCESS_CALLBACK = 'twoFactorSuccessCallback';
var USE_ONETOUCH = 'useOneTouch';
var VERIFY_ENDPOINT = 'verifyEndpoint';
var schema = exports.schema = {
  id: 'authy',
  name: 'Authy',
  keys: {
    AUTHY_API_KEY: AUTHY_API_KEY,
    MESSAGE: MESSAGE,
    REGISTER_ENDPOINT: REGISTER_ENDPOINT,
    REQUIRE_TWO_FACTOR: REQUIRE_TWO_FACTOR,
    SEND_ENDPOINT: SEND_ENDPOINT,
    TWO_FACTOR_SUCCESS_CALLBACK: TWO_FACTOR_SUCCESS_CALLBACK,
    USE_ONETOUCH: USE_ONETOUCH,
    VERIFY_ENDPOINT: VERIFY_ENDPOINT
  },
  requiredKeys: [AUTHY_API_KEY],
  spec: [{
    key: REQUIRE_TWO_FACTOR,
    value: false
  }, {
    key: AUTHY_API_KEY,
    private: true,
    value: ''
  }, {
    key: TWO_FACTOR_SUCCESS_CALLBACK,
    private: true,
    value: ''
  }]
};
var FORMAT_CALL = exports.FORMAT_CALL = 'call';
var FORMAT_ONETOUCH = exports.FORMAT_ONETOUCH = 'onetouch';
var FORMAT_SMS = exports.FORMAT_SMS = 'sms';
var REGISTER_2FA_URL = 'https://xg3s7gjqg3.execute-api.us-east-1.amazonaws.com/prod/authy/register';
var REQUEST_2FA_URL = 'https://xg3s7gjqg3.execute-api.us-east-1.amazonaws.com/prod/authy/send-2fa-request';

function hasIntegration(config) {
  var requireTwoFactor = (0, _config.getValueForIntegration)(config, schema.id, REQUIRE_TWO_FACTOR);
  return requireTwoFactor === true;
}

function register(config, _ref) {
  var email = _ref.email,
      phone = _ref.phone;
  var url = (0, _config.getValueForIntegration)(config, schema.id, REGISTER_ENDPOINT);
  url = url || REGISTER_2FA_URL;
  url += '?componentId=' + config.componentId;
  return _http2.default.makeCall({
    url: url,
    verb: _http2.default.POST,
    data: {
      email: email,
      phone: phone
    }
  });
}

function send2FARequest(config, authyId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data = {
    authyId: authyId
  };

  if (_lodash2.default.includes([FORMAT_CALL, FORMAT_ONETOUCH, FORMAT_SMS], options.format)) {
    data.format = options.format;
  } else if ((0, _config.getValueForIntegration)(config, schema.id, USE_ONETOUCH) === true) {
    data.format = FORMAT_ONETOUCH;
  } else {
    data.format = FORMAT_SMS;
  }

  var message = (0, _config.getValueForIntegration)(config, schema.id, MESSAGE);

  if (!_lodash2.default.isEmpty(message)) {
    data.message = message;
  }

  var url = (0, _config.getValueForIntegration)(config, schema.id, SEND_ENDPOINT);
  url = url || REQUEST_2FA_URL;
  url += '?componentId=' + config.componentId;
  return _http2.default.makeCall({
    url: url,
    verb: _http2.default.POST,
    data: data
  });
}

exports.default = {
  hasIntegration: hasIntegration,
  register: register,
  schema: schema,
  send2FARequest: send2FARequest
};